import { Singleton } from 'app/utils';
import { CurrentUser } from 'app/classes/current.user/current.user';

export class RavenService {

    public api = (window as any).Raven;

    public setupUser(user: CurrentUser) {

        if (!this.api) {
            return;
        }

        this.api.setUserContext({
            id: user.id,
            email: user.email,
            username: `${user.name.first} ${user.name.last}`,
        });

        user.onPrefsChange((prefs) => {
            this.api.setTagsContext(prefs);
        });
    }
}

export let $RavenService = Singleton('$RavenService', RavenService);
